import { SuggestionStatus } from "pages/communication/model/suggestionStatus";

export const getSuggestionStatusBadgeType = (status) => {
  if (status === SuggestionStatus.WAITING) {
    return "waiting";
  }
  if (status === SuggestionStatus.IN_PROGRESS) {
    return "inProgress";
  }
  return "done";
};

export const isSuggestionDone = (status) => status === SuggestionStatus.DONE;

export const isSuggestionAnswered = (status) =>
  status === SuggestionStatus.IN_PROGRESS || status === SuggestionStatus.DONE;

export const mapSuggestionFilterToStatus = (filterLabel) => {
  if (filterLabel === "답변대기") {
    return SuggestionStatus.WAITING;
  }
  if (filterLabel === "진행 중") {
    return SuggestionStatus.IN_PROGRESS;
  }
  if (filterLabel === "답변완료") {
    return SuggestionStatus.DONE;
  }
  return null;
};
